import React, { useState } from "react";
import "./Login.css";
import { Container } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import NavBar from './../../Shared/NavBar/NavBar';
import useAuth from './../../hook/useAuth';
const Login = () => {
  const [loginData, setLoginData] = useState({});
  const { loginUser, isLoading, error } = useAuth();
  let navigate = useNavigate();
  const handleOnchange = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    const newLoginData = { ...loginData };
    newLoginData[field] = value;
    setLoginData(newLoginData);
  };
  const handleLoginSubmit = (e) => {
    loginUser(loginData?.email, loginData?.password, navigate);
    e.preventDefault();
  };
  return (
      <div>
<NavBar/>
    <div className="container mb-5">
      <Container style={{ marginTop: "100px" }}>
            {!isLoading && (
              <form onSubmit={handleLoginSubmit} className="login-form">
                <h4>Login Form</h4>
                <input
                  className="field"
                  required
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  onChange={handleOnchange}
                />
                <input
                  className="field"
                  required
                  placeholder="Your password"
                  type="password"
                  name="password"
                  onChange={handleOnchange}
                />{" "}
                <br />
                <button className="btn btn-dark" type="submit">
                  Login
                </button>{" "}
                <br />
                <NavLink
                  to="/register"
                  style={{
                    textDecoration: "none",
                    color: "black",
                    fontWeight: "bolder",
                    paddingLeft: "10px",
                  }}
                >
                  New User? Please Register
                </NavLink>
              </form>
            )}

            {/* {isLoading && <CircularProgress />} */}
            {error}
         
      </Container>
    </div>
      </div>
  );
};
export default Login;
